import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserStore = defineStore('user', () => {
  const myInfo = ref(null) // TIM 我的信息
  const sdkAppId = ref(null)
  const userSig = ref(null)
  const imUserId = ref(null)

  function setCredentials({ imUserId: uid, userSig: sig, sdkappid }) {
    imUserId.value = uid
    userSig.value = sig
    sdkAppId.value = sdkappid
  }

  function setMyInfo(info) {
    myInfo.value = info
  }

  const myAvatar = computed(() => myInfo.value?.avatar || '')
  const myNick = computed(() => myInfo.value?.nick || myInfo.value?.userID || '')

  function reset() {
    myInfo.value = null
    sdkAppId.value = null
    userSig.value = null
    imUserId.value = null
  }

  return {
    myInfo,
    sdkAppId,
    userSig,
    imUserId,
    myAvatar,
    myNick,
    setCredentials,
    setMyInfo,
    reset
  }
})
